import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export const AUTH_KEY = 'helper-scripts-auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated = false;

  constructor(private http: HttpClient) {
    // Check if user is already authenticated
    this.isAuthenticated = !!localStorage.getItem(AUTH_KEY);
  }

  login(username: string, password: string): Observable<boolean> {
    return this.http.post<{token: string, refreshToken: string, user: any}>(
      `${environment.apiUrl}/auth/login`,
      { username, password }
    ).pipe(
      map(response => {
        this.isAuthenticated = true;
        localStorage.setItem(AUTH_KEY, response.token);
        localStorage.setItem('refresh_token', response.refreshToken);
        localStorage.setItem('user_data', JSON.stringify(response.user));
        return true;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_data');
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated;
  }

  getAuthHeaders(): { Authorization: string } {
    const token = localStorage.getItem(AUTH_KEY);
    if (!token) {
      return { Authorization: '' };
    }
    return {
      'Authorization': `Bearer ${token}`
    };
  }
} 